import { useRef, useState } from "react";

interface PlateValue {
  left: string;
  letter: string;
  right: string;
  city: string;
}

export default function IranPlate({
  valueText,
}: {
  valueText: string;
}) {
  const valueArray = valueText.split('|');

  const [value] = useState<PlateValue>(
    { left: valueArray[0] ?? '', letter: valueArray[1] ?? '', right: valueArray[2] ?? '', city: valueArray[3] ?? '' }
  );
  const letterRef = useRef<HTMLButtonElement>(null);

  const rightRef = useRef<HTMLInputElement>(null);
  const cityRef = useRef<HTMLInputElement>(null);

  const containerClass = 
     "flex items-center bg-gray-50 border-2 border-gray-300 rounded-lg px-1 py-1 text-xl font-bold shadow select-none"

  return (
    <div className="inline-flex flex-col items-center gap-2 font-[Vazirmatn,sans-serif]" dir="ltr">
      <div className={containerClass}>
        <input
          value={value.left}
          inputMode="numeric"
          maxLength={2}
          placeholder="۰۰"
          readOnly={true}
          className={`w-10 text-center outline-none bg-transparent placeholder-gray-300 cursor-default text-gray-600`}
        />

        <div className="relative">
          <button
            ref={letterRef}
            type="button"
            disabled={true}
            className={`w-8 text-center border-b-2 outline-none bg-transparent text-gray-600 border-gray-300 cursor-default"`}
          >
            {value.letter || <span className="text-gray-300 text-base">ب</span>}
          </button>
        </div>

        <input
          ref={rightRef}
          value={value.right}
          inputMode="numeric"
          maxLength={3}
          placeholder="۰۰۰"
          readOnly={true}
          className={`w-14 text-center outline-none bg-transparent placeholder-gray-300 cursor-default text-gray-600" : ""}`}
        />

        <span className="text-gray-400 mx-1">|</span>

        <div className="flex flex-col items-center">
          <input
            ref={cityRef}
            value={value.city}
            inputMode="numeric"
            maxLength={2}
            placeholder="۰۰"
            readOnly={true}
            className={`w-10 text-center outline-none bg-transparent placeholder-gray-300 cursor-default text-gray-600" : ""}`}
          />
          <span className="text-[10px] text-gray-500 leading-none">ایران</span>
        </div>
      </div>
    </div>
  );
}
